import React from "react";
import { MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import ComputerPicture from "../../assets/computer.png";
import Header from "./Header";
import WhatandHowSection from "./WhatandHowSection";
import FeaturesAndBenefits from "./FeaturesAndBenefits";
import Reviews from "./Reviews";
import FAQs from "./FAQs";
import Footer from "./Footer";

const ElecCoop = () => {
  return (
    <div>
      {/* Header */}
      <Header />
      {/* Hero Section */}
      <div className="flex px-20 py-8 pt-8 bg-customSlate-400">
        <div className="flex flex-col gap-2 px-12 mt-20 text-customText-900">
          <h1 className="text-6xl font-extrabold">ELECTRIC COOPERATIVE</h1>
          <span className="text-lg">
            {/* Short description/introduction/tagline for electric cooperative */}
          </span>
          <Link to="/signup">
            <button className="flex items-center px-8 py-2 font-semibold text-lg cursor-pointer mt-8 hover:bg-customGreen-700 rounded-full w-fit gap-2.5 text-customText-100 bg-customGreen-500">
              <MessageCircle className="size-5" />
              Start Chatting Now!
            </button>
          </Link>
        </div>
        <img
          src={ComputerPicture}
          alt=""
          className="h-full"
        />
      </div>
      {/* Elec Coop Section */}
      <WhatandHowSection />
      {/* Features */}
      <div className="flex flex-col gap-20 px-40 pt-32 pb-32 bg-customSlate-400">
        <FeaturesAndBenefits />
      </div>
      {/* Testimonies */}
      {/* <Reviews /> */}
      {/* FAQs */}
      <FAQs />
      <Footer />
    </div>
  );
};

export default ElecCoop;
